export class EmailRelay {
    constructor(
        public applicationGuid: string = '',
        public organizationGuid: string = '',
        public email: string = '',
        public verifiedForSending: boolean = false,
        public cnameRecords?: CnameRecord[],
        public creationStatus?: EmailRelayCreationStatus | null
    ) { }
}

export class CnameRecord {
    constructor(
        public cname: string = ''
    ) { }
}

export enum EmailRelayCreationStatus {
    CREATED_FROM_EXISTING = 'CREATED_FROM_EXISTING'
}
